import React from 'react';
import { MessageInfo } from '@/api/types';
import MediaPreview from './MediaPreview';

interface FileMessageProps {
  message: MessageInfo;
  isOwnMessage: boolean;
}

/**
 * 文件消息组件
 */
const FileMessage: React.FC<FileMessageProps> = ({ message, isOwnMessage }) => {
  const attachment = message.decryptedContentData?.attachment;
  
  if (!attachment?.fileId) {
    return (
      <div className={`px-4 py-2 rounded-2xl ${
        isOwnMessage 
          ? 'bg-red-500 text-white rounded-br-md' 
          : 'bg-red-100 text-red-900 rounded-bl-md'
      }`}>
        <p className="text-sm">文件加载失败</p>
      </div>
    );
  }

  // 获取文件图标
  const getFileIcon = (extension?: string) => {
    if (!extension) return '📄';
    
    const ext = extension.toLowerCase();
    const iconMap: Record<string, string> = {
      'pdf': '📄',
      'doc': '📝',
      'docx': '📝',
      'xls': '📊',
      'xlsx': '📊',
      'ppt': '📽️',
      'pptx': '📽️',
      'txt': '📃',
      'zip': '📦',
      'rar': '📦',
      '7z': '📦',
      'exe': '⚙️',
      'apk': '📱'
    };
    
    return iconMap[ext] || '📄';
  };

  return (
    <div className={`rounded-2xl overflow-hidden max-w-xs md:max-w-md ${
      isOwnMessage ? 'rounded-br-md' : 'rounded-bl-md'
    }`}>
      <div className={`p-4 ${
        isOwnMessage 
          ? 'bg-blue-500 text-white' 
          : 'bg-gray-100 text-gray-900'
      }`}>
        <div className="flex items-center space-x-3 mb-3">
          <span className="text-2xl">{getFileIcon(attachment.fileExtension)}</span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate">
              {attachment.fileName || `文件_${attachment.fileId?.slice(-8)}`}
            </p>
            <div className="flex items-center space-x-2 text-xs opacity-75">
              {attachment.fileExtension && (
                <span className="uppercase">{attachment.fileExtension}</span>
              )}
            </div>
          </div>
        </div>
        
        <MediaPreview
          fileId={attachment.fileId}
          fileName={attachment.fileName}
          fileSize={attachment.fileSize}
          mediaType="file"
        />
      </div>
    </div>
  );
};

export default FileMessage;
